window.addEventListener('DOMContentLoaded', () => {
    let filterBtnArr = document.querySelectorAll('.collection-sidebar__group');

    filterBtnArr.forEach(function(btn) {
        btn.addEventListener('click', function() {
            filterBtnArr.forEach(function(otherBtn) {
                if (otherBtn !== btn) {
                    let dropdown = otherBtn.querySelector('a.collection-sidebar__heading');
                    let dropdownContent = otherBtn.querySelector('ul.filter-drawer__list');
                    let priceDropdown = otherBtn.querySelector('div.filter-drawer__price-range');

                    if (dropdown && !dropdown.classList.contains('closed')) {
                        dropdown.classList.add('closed');
                    }

                    if (dropdownContent && dropdownContent.style.display !== 'none') {
                        dropdownContent.style.display = 'none';
                    }

                    if (priceDropdown && priceDropdown.style.display !== 'none') {
                        priceDropdown.style.display = 'none';
                    }
                }
            })
        })
    })
});